"use client";

import React from 'react';
import Checkmark from '@/components/icons/Checkmark';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface CoverageDetailItemProps {
  label: string;
  value?: string | React.ReactNode;
  isCovered: boolean;
  hideIcon?: boolean;
  isLabelBold?: boolean;
}

const CoverageDetailItem: React.FC<CoverageDetailItemProps> = ({ label, value, isCovered, hideIcon = false, isLabelBold = false }) => {
  return (
    <div className="flex text-md items-center gap-2 py-1 border-b border-border last:border-b-0">
      <div className="flex items-center gap-2">
        {!hideIcon && (
          isCovered ? (
            <Checkmark className="text-primary  h-5 w-5" />
          ) : (
            <X className="h-5 w-5 text-sm text-muted-foreground" />
          )
        )}
        <span className={cn("text-sm", !isCovered && "text-muted-foreground", isLabelBold && "font-bold")}>{label}</span>
      </div>
      {value && <span className="text-sm font-medium text-muted-foreground text-right">{value}</span>}
    </div>
  );
};

export default CoverageDetailItem;
